var _excluded = ["type", "disabled", "size", "level", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import low from '../../../assets/images/emoji_icons/low.svg';
import lowDisabled from '../../../assets/images/emoji_icons/low_disabled.svg';
import neutral from '../../../assets/images/emoji_icons/neutral.svg';
import neutralDisabled from '../../../assets/images/emoji_icons/neutral_disabled.svg';
import high from '../../../assets/images/emoji_icons/high.svg';
import highDisabled from '../../../assets/images/emoji_icons/high_disabled.svg';
import './emoji.scss';
var Emoji = function Emoji(_ref) {
  var _ref2;
  var type = _ref.type,
    disabled = _ref.disabled,
    size = _ref.size,
    level = _ref.level,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var options = ['Low', 'Neutral', 'High'];
  var emojiHash = {
    high: disabled ? highDisabled : high,
    happy: disabled ? highDisabled : high,
    low: disabled ? lowDisabled : low,
    disappointed: disabled ? lowDisabled : low,
    neutral: disabled ? neutralDisabled : neutral
  };
  var iconType = (_ref2 = type || options[level - 1]) === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase();
  var disabledClass = disabled ? 'emoji-disabled' : '';
  var typeClass = "emoji-".concat(iconType);
  var inlineStyles = {
    backgroundImage: "url(".concat(emojiHash[iconType], ")"),
    backgroundSize: 'cover'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", Object.assign({
    className: "emoji emoji-".concat(size, " ").concat(disabledClass, " ").concat(typeClass, " ").concat(className),
    style: inlineStyles
  }, rest)));
};
Emoji.defaultProps = {
  type: undefined,
  disabled: false,
  size: 'sm',
  className: '',
  level: 3
};
export default Emoji;